import { createAsyncThunk } from "@reduxjs/toolkit";
import notificationsService from "../../../api/services/notifications";

export const fetchNotifications = createAsyncThunk(
  "notifications/fetchNotifications",
  async () => await notificationsService.fetchNotifications()
);
